/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcreateplace2Inputs */

const en_crosspostingcreateplace2 = /** @type {(inputs: Crosspostingcreateplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first place`)
};

const de_crosspostingcreateplace2 = /** @type {(inputs: Crosspostingcreateplace2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersten Ort erstellen`)
};

/**
* | output |
* | --- |
* | "Create your first place" |
*
* @param {Crosspostingcreateplace2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcreateplace2 = /** @type {((inputs?: Crosspostingcreateplace2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcreateplace2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcreateplace2(inputs)
	return de_crosspostingcreateplace2(inputs)
});
export { crosspostingcreateplace2 as "crosspostingCreatePlace" }